import Navbar from "../../NavBar/NavBar";
import Footer from "../../Home/Footer.js";
import Whatsapp from "../../Home/Whatsapp.js";
import Spinner from "../../../components/Home/Spinner.js";
import { useEffect } from "react";
import Project6 from "./section_page/Project6.js";

const CanopeeEcoleAmericaine = () => {

  useEffect(() => {
    document.title =
      "Canopée École Américaine – Voiles d’Ombrage & Pergolas | UNIK SYSTEM";

    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Projet Canopée École Américaine : conception et installation de voiles d’ombrage et pergolas par UNIK SYSTEM pour créer des espaces extérieurs protégés, modernes et durables."
    );

    let metaKeywords = document.querySelector("meta[name='keywords']");
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute(
      "content",
      "canopée école américaine, voile d'ombrage école, pergola architecturale, structure metallo textile, ombrage extérieur, UNIK SYSTEM"
    );
  }, []);

  return (
    <div className="body">
      <Spinner />
      <Navbar />
      <Whatsapp />
      <Project6 />
      <Footer />
    </div>
  );
};

export default CanopeeEcoleAmericaine;
